export default "__VITE_ASSET__rfSprM89__"